import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import InternalError from '../components/InternalError';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import AppActions from '../actions/AppActions';

const propTypes = {
  error: React.PropTypes.bool,
  appVersion: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  errorId: PropTypes.string
};

export class InternalErrorContainer extends BcReactComponent {
  unstable_handleError() { // eslint-disable-line camelcase
    this.props.dispatch(AppActions.showErrorPage());
  }

  render() {
    const { appVersion, children, error, errorId } = this.props;
    if (error) {
      return <InternalError appVersion={appVersion} errorId={errorId} />;
    }

    return children;
  }
}

const mapStateToProps = state => ({
  error: state.get('internalError'),
  errorId: state.getIn(['app', 'internalError', 'id']),
  appVersion: state.getIn(['app', 'appVersion'])
});

InternalErrorContainer.propTypes = propTypes;

export default connect(mapStateToProps)(InternalErrorContainer);



// WEBPACK FOOTER //
// ./app/containers/InternalErrorContainer.jsx